"use client";

import { c as _c } from "react/compiler-runtime";
import { getDefaultQueryRetry } from "@/components/react-query-wrapper/utils/query-utils";
import { isMemesQuickVoteVoteableDrop, type MemesQuickVoteStats } from "@/hooks/memesQuickVote.helpers";
import { fetchMemesQuickVoteUndiscoveredDrop, getMemesQuickVoteUndiscoveredDropQueryKey } from "@/hooks/memesQuickVote.query";
import { useMemesQuickVoteContext } from "@/hooks/useMemesQuickVoteContext";
import { WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import { useQuery } from "@tanstack/react-query";
type MemesWaveFooterStats = MemesQuickVoteStats & {
  readonly isAvailable: boolean;
  readonly isReady: boolean;
};
const EMPTY_STATS: MemesWaveFooterStats = {
  isAvailable: false,
  isReady: false,
  uncastPower: null,
  unratedCount: 0,
  votingLabel: null
};
export const useMemesWaveFooterStats = () => {
  const $ = _c(23);
  const {
    contextProfile,
    isEnabled,
    memesWaveId,
    proxyId
  } = useMemesQuickVoteContext();
  const waveId = typeof memesWaveId === "string" && memesWaveId.length > 0 ? memesWaveId : null;
  let t0;
  if ($[0] !== contextProfile || $[1] !== proxyId || $[2] !== waveId) {
    t0 = getMemesQuickVoteUndiscoveredDropQueryKey({
      contextProfile,
      proxyId,
      sessionId: 0,
      skip: 0,
      waveId
    });
    $[0] = contextProfile;
    $[1] = proxyId;
    $[2] = waveId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = isEnabled && waveId !== null;
  let t2;
  if ($[4] !== waveId) {
    t2 = t3 => {
      const {
        signal
      } = t3;
      return fetchMemesQuickVoteUndiscoveredDrop({
        skip: 0,
        signal,
        waveId
      });
    };
    $[4] = waveId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getDefaultQueryRetry();
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t4 = {
      queryKey: t0,
      enabled: t1,
      queryFn: t2,
      staleTime: 60000,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      ...t3
    };
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const query = useQuery(t4);
  const activeDrop = query.data?.drop ?? null;
  const uncastPower = activeDrop?.context_profile_context?.max_rating ?? null;
  let t5;
  if ($[11] !== activeDrop || $[12] !== isEnabled || $[13] !== query.isSuccess || $[14] !== waveId) {
    t5 = isEnabled && waveId !== null && (!query.isSuccess || isMemesQuickVoteVoteableDrop(activeDrop));
    $[11] = activeDrop;
    $[12] = isEnabled;
    $[13] = query.isSuccess;
    $[14] = waveId;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const isAvailable = t5;
  if (!query.isSuccess || !activeDrop || !isMemesQuickVoteVoteableDrop(activeDrop) || typeof uncastPower !== "number") {
    let t6;
    if ($[16] !== isAvailable) {
      t6 = {
        ...EMPTY_STATS,
        isAvailable
      };
      $[16] = isAvailable;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    return t6;
  }
  const t6 = WAVE_VOTING_LABELS[activeDrop.wave.voting_credit_type];
  let t7;
  if ($[18] !== isAvailable || $[19] !== query.data.total_count || $[20] !== t6 || $[21] !== uncastPower) {
    t7 = {
      isAvailable,
      uncastPower,
      unratedCount: query.data.total_count,
      votingLabel: t6,
      isReady: true
    };
    $[18] = isAvailable;
    $[19] = query.data.total_count;
    $[20] = t6;
    $[21] = uncastPower;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};